import { Preferences } from "@capacitor/preferences";
import { hashStringToInt } from "../helpers/hash";
import { LocalNotifications } from "@capacitor/local-notifications";
import {
  getNotificationPreferences,
  isNotificationTypeEnabled,
  shiftOutOfQuietHours,
} from "./notificationPreferences";

const scheduleScheduleNotificationsForTask = async (task) => {
  // Check user notification preferences
  const prefs = await getNotificationPreferences();
  if (!isNotificationTypeEnabled(prefs, "taskReminders", "scheduleStart")) {
    return;
  }

  const scheduledTimeInMs = task.schedule * 1000;

  //Check if task already has notifications scheduled
  const existingNotifications = await Preferences.get({
    key: `task_${task.taskId}_notifications_schedule`,
  });
  if (existingNotifications.value) {
    return;
  }

  console.log("Scheduling schedule notifications for task:", task.taskId);
  const scheduledTime = shiftOutOfQuietHours(
    new Date(scheduledTimeInMs),
    prefs.quietHours,
  );

  //Schedule notification
  const scheduleNotificationId = hashStringToInt(`${task.taskId}-schedule`);
  await LocalNotifications.schedule({
    notifications: [
      {
        title: "It's time to start your task",
        body: `"${task.name}" is scheduled to start now`,
        id: scheduleNotificationId,
        schedule: { at: scheduledTime, allowWhileIdle: true },
        extra: task.taskId,
        channelId: "task_notifications",
      },
    ],
  });
  console.log("Scheduled schedule notification for task:", task.taskId);

  // Update preferences with notification ids
  await Preferences.set({
    key: `task_${task.taskId}_notifications_schedule`,
    value: JSON.stringify({
      scheduleNotificationId,
    }),
  });
};

export default scheduleScheduleNotificationsForTask;
